import { Container } from '../components/Container';
import { Button } from '../components/Button';
import { LogoMark } from '../components/LogoMark';

const APP_STORE_URL = 'https://www.nuvemshop.com.br/loja-de-aplicativos/';

export function Hero() {
  return (
    <section className="hero-section section-hero">
      <Container maxWidth="text">
        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <div style={{ marginBottom: 'var(--spacing-lg)' }}>
            <LogoMark size={56} />
          </div>

          <h1
            className="hero-headline"
            style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 800,
              color: '#FFFFFF',
              lineHeight: 1.1,
            }}
          >
            Venda por assinatura na Nuvemshop
          </h1>

          <p
            style={{
              fontSize: '16px',
              fontWeight: 400,
              color: 'rgba(255,255,255,0.80)',
              maxWidth: 560,
              margin: 'var(--spacing-lg) auto 0',
              lineHeight: 1.5,
            }}
          >
            Seus clientes assinam, o pagamento é cobrado automaticamente, e o
            pedido aparece na sua loja. Zero trabalho manual por ciclo.
          </p>

          <div className="hero-cta" style={{ marginTop: 'var(--spacing-xl)' }}>
            <Button variant="gradient" href={APP_STORE_URL}>
              Instalar no Nuvemshop
            </Button>
          </div>

          <p
            style={{
              fontSize: '14px',
              fontWeight: 400,
              color: 'rgba(255,255,255,0.50)',
              marginTop: 'var(--spacing-md)',
            }}
          >
            Grátis para testar. Cancele quando quiser.
          </p>
        </div>
      </Container>

      <style>{`
        .hero-section {
          position: relative;
          background: var(--brand-dark);
          color: #ffffff;
          padding: var(--spacing-4xl) var(--spacing-md);
          overflow: hidden;
        }
        .hero-section::before {
          content: '';
          position: absolute;
          bottom: -40%;
          left: -10%;
          right: -10%;
          height: 80%;
          background: radial-gradient(
            ellipse 70% 100% at 50% 100%,
            rgba(168,85,247,0.30) 0%,
            rgba(232,67,147,0.15) 40%,
            transparent 70%
          );
          pointer-events: none;
        }
        .hero-section::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(168,85,247,0.3), rgba(232,67,147,0.3), transparent);
        }
        .hero-headline {
          font-size: 40px;
        }
        @media (max-width: 1023px) {
          .hero-headline {
            font-size: 32px;
          }
        }
        @media (max-width: 639px) {
          .hero-section {
            padding: var(--spacing-2xl) var(--spacing-md) !important;
          }
          .hero-cta a {
            display: block !important;
            width: 100% !important;
          }
        }
      `}</style>
    </section>
  );
}
